import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '@generic/index';
import { ResetPasswordModel } from '../../models/ResetPasswordModel';
import { AccountService } from '../../services/account.service';
import Swal from 'sweetalert2/dist/sweetalert2.all.min.js';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  model: ResetPasswordModel;
  serverError: string[] = null;
  success = false;
  navigationSubscription: Subscription;
  sub: string[];
  URL: string;
  constructor(
    private route: ActivatedRoute,
    private api: AccountService,
    private router: Router,
    private auth: AuthService
  ) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.initialize();
      }
    });
  }
  initialize() {
    this.auth.clearLogout();
    this.serverError = null;
    this.success = false;
    this.route.queryParams.subscribe(params => {
      this.success = params['success'] === 'true';
      this.model.token = params['token'];
      this.model.id = params['uid'];
    });
  }

  ngOnInit() {
    this.model = new ResetPasswordModel();
    this.URL = this.router.url;
    this.sub = this.URL.split(/[?]/);
    this.model.userName = this.sub[1];
  }
  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  confirmPasswordReset() {
    this.api.resetPassword(this.model).subscribe(
      data => {
        if (data.status) {
          Swal.fire('', 'Password changed successfully. Please login again', 'success').then((result) => {
            if (result) {
              this.auth.clearLogout();
              this.auth.goToLoginPage();
            }
          });
        } else {
          Swal.fire('', data.message, 'error');
        }
      },
      err => {
        Swal.fire('', 'Server Error - Please try later', 'error');
      }
    );
  }
  login() {
    this.auth.goToLoginPage();
  }
  reload() {
    const url = `account/reset-password?uid=${this.model.id}&token=${
      this.model.token
    }&t=${new Date().toJSON()}`;
    this.router.navigateByUrl(url);
  }
}
